import { useState, useCallback } from 'react'
import { SprintStatus } from '../../../../../lib/functions/sprint'
import { EXPANDED_STATUSES } from './types'

/**
 * ステータスグループの展開/折りたたみ状態を管理するフック
 * INPROGRESS, STANDBY はデフォルトで展開
 */
export const useExpandableStatuses = () => {
  const [expandedStatuses, setExpandedStatuses] = useState<Set<SprintStatus>>(
    () => new Set(EXPANDED_STATUSES)
  )

  const toggleStatus = useCallback((status: SprintStatus) => {
    setExpandedStatuses(prev => {
      const next = new Set(prev)
      if (next.has(status)) {
        next.delete(status)
      } else {
        next.add(status)
      }
      return next
    })
  }, [])

  return { expandedStatuses, toggleStatus }
}
